import { constantRouterMap, asyncRouterMap } from '../../router'

const router = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    // 设置路由表
    SET_ROUTERS (state, router) {
      state.addRouters = router.add
      state.routers = router.new
    }
  },
  actions: {
    // 生成可访问的路由表
    GenerateRoutes ({ commit, state }, data) {
      return new Promise((resolve) => {
        let power = data[0]
        let isSspUser = data[1]
        let accessedRouters = []
        // let accessedRoutersArr = JSON.parse(JSON.stringify(asyncRouterMap))
        // 根据模块权限值生成当前角色路由表
        for (let val of asyncRouterMap) {
          // 是否存在菜单级路由
          if (val.children) {
            let children = []
            for (let vall of val.children) {
              if (vall.meta) {
                let metaId1 = power[vall.meta.id]
                if (metaId1 && (((metaId1.powerValue & vall.meta.power[0]) === vall.meta.power[0]) || ((metaId1.powerValue & vall.meta.power[1]) === vall.meta.power[1]))) {
                  // 是否存在功能级子路由
                  if (vall.children) {
                    let childrenn = []
                    for (let valll of vall.children) {
                      let metaId2 = power[valll.meta.id]
                      if (metaId2 && (((metaId2.powerValue & valll.meta.power[0]) === valll.meta.power[0]) || ((metaId2.powerValue & valll.meta.power[1]) === valll.meta.power[1]))) {
                        if (valll.meta.isIn) {
                          if (isSspUser) {
                            childrenn.push(valll)
                          }
                        } else {
                          childrenn.push(valll)
                        }
                      }
                    }
                    if (childrenn.length > 0) {
                      vall.children = childrenn
                      children.push(vall)
                    }
                  } else {
                    if (vall.meta.isIn) {
                      if (isSspUser) {
                        children.push(vall)
                      }
                    } else {
                      children.push(vall)
                    }
                  }
                }
              } else {
                children.push(vall)
              }
            }
            if (children.length > 0) {
              val.children = children
              accessedRouters.push(val)
            }
          } else if (val.hidden) {
            accessedRouters.push(val)
          }
        }
        commit('SET_ROUTERS', {add: accessedRouters, new: constantRouterMap.concat(accessedRouters)})
        resolve()
      })
    },
    // 注销登录
    FedLogOut ({ commit }) {
      return new Promise((resolve) => {
        window.sessionStorage.clear()
        commit('SET_TOKENAndUSER', {token: '', user: {}})
        commit('SET_ROUTERS', {add: [], new: constantRouterMap})
        resolve()
      })
    }
  },
  getters: {
    // 获取可访问路由
    addRouters (state) {
      return state.routers
    },
    // 权限路由表是否已生成
    isAddRouters (state) {
      let ble = false
      if (state.addRouters.length === 0) {
        ble = true
      }
      return ble
    },
    // 生成角色侧边栏导航列表
    getAsideNavList (state) {
      const addRouters = state.addRouters[0]
      const addRoutersPath = addRouters.path
      const addRoutersChild = addRouters.children
      let asideNavList = []
      for (let key in addRoutersChild) {
        let val = addRoutersChild[key]
        if (val.aside) {
          const valObj = {name: val.name, icon: val.icon || '', path: `${addRoutersPath}/${val.path}`}
          if (val.father) {
            let _JSON = JSON.stringify(asideNavList)
            if (_JSON.indexOf(val.father) > -1) {
              for (let key in asideNavList) {
                if (asideNavList[key].name === val.father) {
                  asideNavList[key].children.push(valObj)
                  break
                }
              }
            } else {
              asideNavList.push({name: val.father, icon: val.fatherIcon, path: `father${key}`, children: [valObj]})
            }
          } else {
            asideNavList.push(valObj)
          }
        }
      }
      return asideNavList
    }
  }
}

export default router



// WEBPACK FOOTER //
// ./src/store/modules/router.js